import { initLoginModalScripts } from "./loginModalScripts";
import { initRegisterModalScripts } from "./registerModalScripts";
import { initRecoveryModalScripts } from "./recoveryModalScripts";

let modal = null;

function fetchModal(modalType) {

    return fetch(`/local/ajax/getAuthModal.php?type=${modalType}&ismobile=${window.IS_MOBILE}`)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text();
        })
        .catch(error => {
            console.error('Ошибка при загрузке данных:', error);
            throw error;
        });
}

function addClickEvents(type) {
    const callBtn = $(`#modal-${type}`);
    callBtn.on("click", function (e) {
        e.preventDefault()
        fetchModal(type)
            .then(html => {
                modal.setContent(html);
                switch (type) {
                    case 'login':
                        initLoginModalScripts(modal.modalElement);
                        addClickEvents('register');
                        addClickEvents('recovery');
                        break;
                    case 'register':
                        initRegisterModalScripts(modal.modalElement);
                        addClickEvents('login');
                        break;
                    case 'recovery':
                        initRecoveryModalScripts(modal.modalElement);
                        addClickEvents('login');
                        addClickEvents('register');
                        break;
                    default:
                        throw new Error(`Unknown modal type: ${type}`);
                }

                modal.show();
            })
            .catch(error => {
                console.error('Ошибка при загрузке данных:', error);
            });
    });
}

export function initModalListeners() {
    const headerLoginModalBtn = $("#header-auth");

    headerLoginModalBtn.on("click", function () {
        fetchModal("login")
            .then(html => {
                const wrappedHtml = `
                <div class="product-modal modal-classic modal-area">
                    ${App.components.Modal.closeHtml}
                    ${html}
                </div>
                `
                modal = new App.components.Modal("authModal", wrappedHtml);
                initLoginModalScripts(modal.modalElement);
                addClickEvents('register');
                addClickEvents('recovery');
                modal.show();
            })
            .catch(error => {
                console.error('Ошибка при загрузке данных:', error);
            });
    });
}
